<template>
  <section class="container">
    <ProductList :list="product.list" :loading="false"></ProductList>

    <Pages v-if="product.list.length" @numberChange="numberChange" :last="product.page_count"></Pages>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      loading: false,
      cid: this.$route.query.cid,
      page: 1,
      product: {
        page_count: 1,
        list: [],
      },
    };
  },
  methods: {
    async productIndex() {
      this.loading = true;
      let res = await service.productIndex({ cid: this.cid, page: this.page });
      this.loading = false;
      if (res.code == 1) {
        this.product = res.data.product;
      }
    },
    numberChange(number) {
      this.page = number;
    },
  },
  created() {
    this.productIndex();
  },
  watch: {
    $route(to, from) {
      this.cid = to.query.cid;
    },
    page() {
      this.productIndex();
    },
    cid() {
      this.productIndex();
    },
  },
};
</script>

<style></style>